/**
 * 押印の傾き（ui-design.md §5.10・§6.1）。
 * 「段の ID から決めて算出する（再訪で角度が変わらない）」ため、時刻や乱数を使わず、
 * ID 文字列だけを入力とする純粋関数（決定的ハッシュ）にしている。
 * 出力範囲は -2.00°〜+2.00°（§6.1「押印のたわみ・欠けは CSS の回転（-2°〜+2°）で与える」）。
 */

const TILT_RANGE_DEGREES = 2;
const HASH_MULTIPLIER = 31;
const HASH_MODULUS = 401; // 0..400 → 401等分することで -2.00〜+2.00 を含む範囲に均等分布させる

/** 文字列から決定的な符号なしハッシュ値を得る（同じ入力には常に同じ出力）。 */
function hashString(id: string): number {
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (Math.imul(hash, HASH_MULTIPLIER) + id.charCodeAt(i)) >>> 0;
  }
  return hash;
}

/** `levelId`（または`"grand"`）から、その朱印の傾き角度（度）を決定的に算出する。 */
export function computeStampTilt(id: string): number {
  const hash = hashString(id);
  const steps = hash % HASH_MODULUS; // 0..400
  const degrees = (steps / HASH_MODULUS) * (TILT_RANGE_DEGREES * 2) - TILT_RANGE_DEGREES;
  return Number(degrees.toFixed(2));
}
